/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AdditionalEquipmentFromJSON, AdditionalEquipmentToJSON, AgreementFromJSON, AgreementToJSON, ApplicationUserFromJSON, ApplicationUserToJSON, CarBodyTypeFromJSON, CarBodyTypeToJSON, CarFileModelRelationFromJSON, CarFileModelRelationToJSON, CarFilePhotoRelationFromJSON, CarFilePhotoRelationToJSON, CarModelDictionaryValueFromJSON, CarModelDictionaryValueToJSON, CarPaintProtectionTypeFromJSON, CarPaintProtectionTypeToJSON, CarSeasonTireFromJSON, CarSeasonTireToJSON, CarStatusFromJSON, CarStatusToJSON, ColorDictionaryValueFromJSON, ColorDictionaryValueToJSON, DriveTypeFromJSON, DriveTypeToJSON, FuelTypeFromJSON, FuelTypeToJSON, GarageSpotFromJSON, GarageSpotToJSON, GearTypeFromJSON, GearTypeToJSON, LeasingAgreementFromJSON, LeasingAgreementToJSON, PaintEffectTypeFromJSON, PaintEffectTypeToJSON, ProtocolFromJSON, ProtocolToJSON, ReservationFromJSON, ReservationToJSON, } from './';
export function CarFromJSON(json) {
    return CarFromJSONTyped(json, false);
}
export function CarFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'carModel': CarModelDictionaryValueFromJSON(json['carModel']),
        'carModelId': !exists(json, 'carModelId') ? undefined : json['carModelId'],
        'carModelVariant': !exists(json, 'carModelVariant') ? undefined : json['carModelVariant'],
        'plateNumber': json['plateNumber'],
        'vin': !exists(json, 'vin') ? undefined : json['vin'],
        'fuel': !exists(json, 'fuel') ? undefined : FuelTypeFromJSON(json['fuel']),
        'engineOil': !exists(json, 'engineOil') ? undefined : json['engineOil'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'engineCapacity': !exists(json, 'engineCapacity') ? undefined : json['engineCapacity'],
        'acceleration': !exists(json, 'acceleration') ? undefined : json['acceleration'],
        'maxSpeed': !exists(json, 'maxSpeed') ? undefined : json['maxSpeed'],
        'mass': !exists(json, 'mass') ? undefined : json['mass'],
        'manufactureYear': !exists(json, 'manufactureYear') ? undefined : json['manufactureYear'],
        'firstRegistration': !exists(json, 'firstRegistration') ? undefined : (json['firstRegistration'] === null ? null : new Date(json['firstRegistration'])),
        'currentMileage': !exists(json, 'currentMileage') ? undefined : json['currentMileage'],
        'paintEffect': !exists(json, 'paintEffect') ? undefined : PaintEffectTypeFromJSON(json['paintEffect']),
        'currentWorth': !exists(json, 'currentWorth') ? undefined : json['currentWorth'],
        'monthLimit': !exists(json, 'monthLimit') ? undefined : json['monthLimit'],
        'yearLimit': !exists(json, 'yearLimit') ? undefined : json['yearLimit'],
        'gear': !exists(json, 'gear') ? undefined : GearTypeFromJSON(json['gear']),
        'drive': !exists(json, 'drive') ? undefined : DriveTypeFromJSON(json['drive']),
        'bodyColorId': !exists(json, 'bodyColorId') ? undefined : json['bodyColorId'],
        'bodyColor': !exists(json, 'bodyColor') ? undefined : ColorDictionaryValueFromJSON(json['bodyColor']),
        'bodyType': !exists(json, 'bodyType') ? undefined : CarBodyTypeFromJSON(json['bodyType']),
        'bodyColorMakeCode': !exists(json, 'bodyColorMakeCode') ? undefined : json['bodyColorMakeCode'],
        'calendarColorRGB': !exists(json, 'calendarColorRGB') ? undefined : json['calendarColorRGB'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'paintProtection': !exists(json, 'paintProtection') ? undefined : CarPaintProtectionTypeFromJSON(json['paintProtection']),
        'status': CarStatusFromJSON(json['status']),
        'remarks': !exists(json, 'remarks') ? undefined : json['remarks'],
        'additionalEquipments': !exists(json, 'additionalEquipments') ? undefined : (json['additionalEquipments'] === null ? null : json['additionalEquipments'].map(AdditionalEquipmentFromJSON)),
        'agreements': !exists(json, 'agreements') ? undefined : (json['agreements'] === null ? null : json['agreements'].map(AgreementFromJSON)),
        'leasingAgreements': !exists(json, 'leasingAgreements') ? undefined : (json['leasingAgreements'] === null ? null : json['leasingAgreements'].map(LeasingAgreementFromJSON)),
        'reservations': !exists(json, 'reservations') ? undefined : (json['reservations'] === null ? null : json['reservations'].map(ReservationFromJSON)),
        'protocols': !exists(json, 'protocols') ? undefined : (json['protocols'] === null ? null : json['protocols'].map(ProtocolFromJSON)),
        'photoFiles': !exists(json, 'photoFiles') ? undefined : (json['photoFiles'] === null ? null : json['photoFiles'].map(CarFilePhotoRelationFromJSON)),
        'modelFiles': !exists(json, 'modelFiles') ? undefined : (json['modelFiles'] === null ? null : json['modelFiles'].map(CarFileModelRelationFromJSON)),
        'tiresNotes': !exists(json, 'tiresNotes') ? undefined : json['tiresNotes'],
        'tires': !exists(json, 'tires') ? undefined : (json['tires'] === null ? null : json['tires'].map(CarSeasonTireFromJSON)),
        'garageSpotId': !exists(json, 'garageSpotId') ? undefined : json['garageSpotId'],
        'garageSpot': !exists(json, 'garageSpot') ? undefined : GarageSpotFromJSON(json['garageSpot']),
    };
}
export function CarToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'carModel': CarModelDictionaryValueToJSON(value.carModel),
        'carModelId': value.carModelId,
        'carModelVariant': value.carModelVariant,
        'plateNumber': value.plateNumber,
        'vin': value.vin,
        'fuel': FuelTypeToJSON(value.fuel),
        'engineOil': value.engineOil,
        'enginePower': value.enginePower,
        'engineCapacity': value.engineCapacity,
        'acceleration': value.acceleration,
        'maxSpeed': value.maxSpeed,
        'mass': value.mass,
        'manufactureYear': value.manufactureYear,
        'firstRegistration': value.firstRegistration === undefined ? undefined : (value.firstRegistration === null ? null : value.firstRegistration.toISOString().substr(0, 10)),
        'currentMileage': value.currentMileage,
        'paintEffect': PaintEffectTypeToJSON(value.paintEffect),
        'currentWorth': value.currentWorth,
        'monthLimit': value.monthLimit,
        'yearLimit': value.yearLimit,
        'gear': GearTypeToJSON(value.gear),
        'drive': DriveTypeToJSON(value.drive),
        'bodyColorId': value.bodyColorId,
        'bodyColor': ColorDictionaryValueToJSON(value.bodyColor),
        'bodyType': CarBodyTypeToJSON(value.bodyType),
        'bodyColorMakeCode': value.bodyColorMakeCode,
        'calendarColorRGB': value.calendarColorRGB,
        'location': value.location,
        'paintProtection': CarPaintProtectionTypeToJSON(value.paintProtection),
        'status': CarStatusToJSON(value.status),
        'remarks': value.remarks,
        'additionalEquipments': value.additionalEquipments === undefined ? undefined : (value.additionalEquipments === null ? null : value.additionalEquipments.map(AdditionalEquipmentToJSON)),
        'agreements': value.agreements === undefined ? undefined : (value.agreements === null ? null : value.agreements.map(AgreementToJSON)),
        'leasingAgreements': value.leasingAgreements === undefined ? undefined : (value.leasingAgreements === null ? null : value.leasingAgreements.map(LeasingAgreementToJSON)),
        'reservations': value.reservations === undefined ? undefined : (value.reservations === null ? null : value.reservations.map(ReservationToJSON)),
        'protocols': value.protocols === undefined ? undefined : (value.protocols === null ? null : value.protocols.map(ProtocolToJSON)),
        'photoFiles': value.photoFiles === undefined ? undefined : (value.photoFiles === null ? null : value.photoFiles.map(CarFilePhotoRelationToJSON)),
        'modelFiles': value.modelFiles === undefined ? undefined : (value.modelFiles === null ? null : value.modelFiles.map(CarFileModelRelationToJSON)),
        'tiresNotes': value.tiresNotes,
        'tires': value.tires === undefined ? undefined : (value.tires === null ? null : value.tires.map(CarSeasonTireToJSON)),
        'garageSpotId': value.garageSpotId,
        'garageSpot': GarageSpotToJSON(value.garageSpot),
    };
}
